import React from "react";

export default function ChatMessages(props) {
  const messages = props.messages || [];
  if (!Array.isArray(messages)) return null;

  const ChatMessageAvatar = () => {
    return (
      <div className="symbol symbol-circle symbol-40">
        <span class="symbol-label font-size-h5">A</span>
      </div>
    );
  };

  const ChatMessageDate = (props) => {
    return (
      <span className="text-muted font-size-sm">
        {props.message.date.toLocaleDateString()}
      </span>
    );
  };

  return (
    <>
      <div className="messages-continer ">
        {messages.map((message) => {
          const alignRight = message.right ? true : false;

          return (
            <div
              className={`d-flex flex-column mb-5 align-items-${
                alignRight ? "end" : "start"
              }`}
            >
              <div className="d-flex align-items-center">
                {!alignRight && <ChatMessageAvatar />}
                <div>
                  {alignRight && <ChatMessageDate message={message} />}
                  <span className="text-dark-75 mx-3 font-weight-bold font-size-h6">
                    {message.author}
                  </span>
                  {!alignRight && <ChatMessageDate message={message} />}
                </div>
                {alignRight && <ChatMessageAvatar />}
              </div>
              <div
                style={{ whiteSpace: "pre-line" }}
                className={`mt-2 rounded p-5 ${
                  alignRight ? "bg-light-primary" : "bg-light-success"
                } text-dark-50 font-weight-bold font-size-lg text-left max-w-400px`}
              >
                {message.text}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}
